import React from "react";

import { CardRow, StructureSection } from "../OpenBoxQuotes/BoxStructureFields";
import { AccessoryNoteCard } from "./AccessoriesCards";
import { closedKey } from "./BoxStructureCards";

const LOCK_CARDS = [
  ["hydraulicControlBoxLock", "HYDRAULIC_CONTROL_BOX_LOCK"],
  ["ureaLock", "UREA_LOCK"],
  ["dieselLock", "DIESEL_LOCK"],
  ["sideDoorLock", "SIDE_DOOR_LOCK"],
  ["hydraulicSideLockEar", "HYDRAULIC_SIDE_LOCK_EAR"],
  ["batteriesLock", "BATTERIES_LOCK"],
] as const;

const AccessoriesLocks = () => (
  <StructureSection titleKey={closedKey("SECTIONS.LOCKS")}>
    <CardRow columns={3}>
      {LOCK_CARDS.slice(0, 3).map(([cardKey, title]) => (
        <AccessoryNoteCard
          key={cardKey}
          cardKey={cardKey}
          titleKey={closedKey(`CARDS.${title}`)}
        />
      ))}
    </CardRow>
    <CardRow columns={3}>
      {LOCK_CARDS.slice(3).map(([cardKey, title]) => (
        <AccessoryNoteCard
          key={cardKey}
          cardKey={cardKey}
          titleKey={closedKey(`CARDS.${title}`)}
        />
      ))}
    </CardRow>
  </StructureSection>
);

export default AccessoriesLocks;
